<template>
    <main class="pedido">
        <div class="container px-2 px-sm-0  px-lg-3 pg-inter-pedido ">
            <div class="sombra-direita"></div>
            <div class="sombra-esquerda"></div>
            <div class="principal bg-white mt-5">
                <div class="dados-cadastrais">
                    <header class="header-pagina">
                        <h3>Pedido finalizado</h3>
                    </header>
                </div>
                <div class="p-3">
                    <div class="card pedido">
                        <div class="detalhe-pedido px-0" v-if="pedido">
                            <div class="col-md-12 text-center card-header py-3 bg-light">
                                <h5 class="mb-0">
                                    <strong>Número do Pedido: </strong> <span class="text-primary py-2 px-3 bg-white rounded-pill"> {{pedido.numeroPedido}}</span>
                                </h5>
                            </div>
                            <div class="card-body">
                                <div class="row">


                                    <div class="w-100 row m-auto">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label class=""><strong>Forma de Pagamento:</strong></label>
                                                    <span class="text-primary fsize18"> {{pedido.valorLiquido ? pedido.pedidoPagamento.formaPagamento.nome:'Pedido Reservado'}} </span>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class=""><strong>Status do Pedido:</strong></label>
                                                    <span class="text-primary fsize18"> {{pedido.statusPedido.nome}} </span>
                                                </div>

                                                <div class="col-md-4">
                                                    <label class=""><strong>Valor:</strong></label>
                                                    <span class="text-primary fsize18"> {{pedido.valorLiquido ? formatPrice(pedido.valorLiquido) : '--'}}</span>
                                                </div>

                                                <div class="check-pedido col-md-1">
                                                    <i class="fas fa-check-circle"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="w-100" />
                                        <div class="col-md-12 produto-finalizado vitrine-produtos">
                                            <div class="row row-cols-1 row-cols-md-3">
                                                <div class="col-md-3 mb-4 " v-for="item in pedido.collectionPessoaProduto">
                                                    <div class="card h-100">
                                                        <div class="img-produto overflow-hidden">
                                                            <img :src="item.produto.imagem" class="card-img-top" alt="...">
                                                        </div>
                                                        <h5 class="card-title p-2"><strong>{{item.produto.nome}}</strong></h5>
                                                        <div class="card-body p-2 ">

                                                            <p class="card-text ">
                                                                <strong>Aluno: </strong> <span class="text-capitalize">{{item.nomeDestinatario}}</span><br />
                                                            </p>
                                                            <p class="card-text ">
                                                                <strong>Promoção: </strong><span class="text-capitalize">{{item.promocao ? item.promocao.nome : ' -- '}}</span>
                                                            </p>
                                                            <p></p>
                                                        </div>
                                                        <div class="card-footer bg-info text-white">
                                                            <h5 class="m-0 text-right">
                                                                <span class="text-uppercase fsize14 ">
                                                                    Valor:
                                                                </span>
                                                                <strong>  {{item.valor ? formatPrice(item.valorLiquido) : '--'}}</strong>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="title text-center text-danger bg-white pb-5">
                    <div class="chamada-logo">
                        <img src="../../assets/images/arrow.png" class="logo_instituto" />
                    </div>
                    <h4>
                        <strong>Você sabia que parte do valor de seu pedido é destinado ao <br /><img src="../../assets/images/institucionalcnaazul.png" /></strong>
                    </h4>
                </div>
            </div>
        </div>

        <section class="instituto-cna">

            <div class="banner_instituto d-table">
                <h2 class="text-center text-white mb-5"><strong>Descubra o Jeito CNA de mudar o mundo</strong></h2>
                <div class="bg-danger text-center mt-5 px-3 py-2 w-auto m-auto d-table rounded-pill">
                    <!--<h3 class="text-white m-0"><strong>SAIBA MAIS</strong></h3>-->
                    <a href="#" class="text-decoration-none" v-scroll-to="'#elemento'"><h3 class="text-white m-0"><strong>SAIBA MAIS</strong></h3></a>
                </div>

            </div>
            <div id="elemento" class="saiba-mais">
                <div class="container">
                    <h2 class="text-danger my-5 text-center"><strong>CONHEÇA O INSTITUTO</strong></h2>
                    <hr />
                    <div class="media">
                        <img src="../../assets/images/banners_criancas_406x406.jpg" class="img-fluid mr-md-3" alt="...">
                        <div class="media-body text-justify">
                            <h4 class="mt-0 text-primary mb-4"><strong>SOBRE O INSTITUTO CNA</strong></h4>
                            <p style="font-size: 18px;">
                                Localizado em uma das regiões mais vulneráveis da cidade de São Paulo, o Instituto CNA, uma organização sem fins lucrativos, tem sido um agente de transformação desde 2001.
                            </p>
                            <p style="font-size: 18px;">
                                Ao longo desses anos, já beneficiou milhares de crianças com idades entre 4 e 6 anos, proporcionando-lhes acesso à educação de qualidade, experiências culturais, alimentação saudável a oportunidade de sonhar alto, de alcançar "um sonho grande".
                            </p>
                        </div>
                    </div>
                    <div class="videos-instituicao mt-4">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/3yve2e2Pv2k" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/N03KkQHVOco" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="d-table w-100 bg-light mt-4 py-5 text-center">
                    <div class="w-100">
                        <!--<h2 class="text-danger text-center mb-4"><strong>COMO PARTICIPAR</strong></h2>-->
                        <h2 class="text-danger text-center mb-4"><strong>Para saber mais sobre o Instituto CNA e como você pode contribuir, visite nosso site:<a href="https://www.institutocna.org/" target="_blank"> www.institutocna.org</a></strong></h2>

                        <!--<div class="col-md-6 float-left">
                            <div class="doacao">
                                <div class="input-group mb-3 py-3 px-5 bg-white rounded-pill">
                                    <input type="text" class="form-control" placeholder="Coloque o valor da sua doação aqui" aria-label="Recipient's username" aria-describedby="button-addon2">

                                    <div class="input-group-append">
                                        <button class="btn btn-raised btn-danger" type="button" id="button-addon2">DOAR</button>
                                    </div>

                                </div>

                            </div>
                        </div>-->
                        <!--<div class="col-md-6 float-left">
                            <h4 class="mt-0 text-primary mb-4"><strong>CONTRIBUA!</strong></h4>
                            <p>
                                Associação Moacyr Nogueira da Gama<br />
                                CNPJ 05.076.800/0001-00<br />
                                Banco Bradesco Ag. 1074-0 C/C. 43012-9<br />
                                A/c Tamara Bariani Tel. (11) 3053-3928
                            </p>
                        </div>-->

                    </div>
                </div>
                <div class="footer-instituicao text-center">
                    <img src="../../assets/images/institutocna.png" />
                    <p class="text-white my-5">
                        TODOS OS DIREITOS RESERVADOS. INSTITUTO CNA. © 2019
                    </p>
                </div>
            </div>
        </section>

    </main>
</template>




<script>
    import { Api } from '@/common/api'
    export default {
        name: 'pedido',
        data() {
            return {
                pedido: null,
                IdsPedido: null,
            }
        },
        methods: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return 'R$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            carregarDetalhesPedidos() {

                new Api("pedido").get({ id: this.IdsPedido }).then(result => {

                    if (result.data) {
                        this.pedido = result.data;
                    }
                    else {
                        this.$swal({
                            type: 'error',
                            title: 'Pedidos não encontrado',
                            text: 'Seus pedidos não foram encontrados!',
                            modal: true,
                            onAfterClose: () => {
                                setTimeout(() => { window.location = "/home"; }, 500);
                            },
                        });
                    }


                }, err => {
                    this.defaultErrorResult(err, true);
                    setTimeout(() => { window.location = "/home"; }, 3000);
                })

            },
        },
        mounted() {
            this.IdsPedido = this.$route.query.id;
            this.carregarDetalhesPedidos();
        }
    };
</script>


<style lang="scss" scoped>

    .check-pedido {
        position: absolute;
        right: 0px;
        top: -25px;
        font-size: 50px;
        z-index: 1000;
        color: #82C91E;
        text-align: right;
        text-shadow: 3px 3px 4px #cccccc;
    }

    .chamada-logo {
        height: 120px;
        width: 100%;
        margin-top: -15px;
        position: relative;
        z-index: 1000;
    }

    .logo_instituto {
        animation: pulapula 0.8s linear infinite alternate;
    }

    .produto-finalizado h5 {
        font-size: 18px !important;
    }
    /* Keyframes */
    @keyframes pulapula {
        0% {
            margin-top: -30px;
        }

        50% {
            margin-top: -80px;
        }

        100% {
            margin-top: -30px;
        }
    }

    .logo_instituto {
        margin-top: -30px;
    }

    .instituto-cna {
        font-family: Roboto Condensed;

        h4 {
            img {
                width: 200px;
            }
        }


        h2 {
            font-size: 46px;
        }


        .banner_instituto {
            background-image: url(../../assets/images/banners_instituto_shopping_cna.jpg);
            background-repeat: no-repeat;
            background-size: cover;
            background-attachment: fixed;
            height: 400px;
            width: 100%;
            padding: 150px;
        }

        .saiba-mais {
            background-image: url(../../assets/images/img-fundoinstitutocna.jpg);
            background-repeat: no-repeat;
            background-size: cover;
            display: table;
            width: 100%;
        }

        .doacao {
            padding: 50px 0;
            width: 100%;

            .input-group {
                width: 400px;
                margin: 0 auto;
            }
        }

        .footer-instituicao {
            background-color: #003c8c;
            height: 447px;
            width: 100%;
            padding: 100px 0;
        }
    }

    .fsize14 {
        font-size: 14px;
    }

    .fsize18 {
        font-size: 18px;
    }

    .fsize20 {
        font-size: 20px;
    }

    @media (max-width: 576px) {

        .produto-finalizado {
            margin-top: 30px;
        }

        .produto-finalizado label {
            width: 100%;
            text-align: center;
            font-size: 22px;
        }

        .banner_instituto {
            padding: 90px 20px !important;
            background-position: center;
        }

        .instituto-cna .doacao .input-group {
            width: 90%;
        }

        .videos-instituicao .embed-responsive {
            margin-top: 10px;
        }
    }
</style>